import BaseCtrl from 'edge/platform/base/BaseCtrl';
import uwutil from 'edge/gateway/util/UWUtil';

const fn = ($scope, ActivityService, $stateParams, UserService, $filter, InsuranceSuiteMetadata, PolicyChangeService) => {
    const ctrl = Object.create(BaseCtrl);

    $scope.policyChangeNumber = $stateParams.policyChangeNumber;
    $scope.unfilteredActivities = [];
    $scope.policyChangeService = PolicyChangeService;
    $scope.showContinuePolicyChangeButton = false;

    ctrl.canWithdraw = () => {
        if ($scope.policyChange) {
            if ($scope.policyChange.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Withdrawn').name) {
                return false;
            } else if (($scope.policyChange.status !== InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Bound').name) && !$scope.policyChange.closeDate) {
                return true;
            }
        }
        return false;
    };

    function canContinuePolicyChange() {
        const permissionDTO = {
            permission: 'createpolchange'
        };
        const actPromise = UserService.hasUserSystemPermission(permissionDTO);
        actPromise.then((showPolicyChange) => {
            $scope.showContinuePolicyChangeButton = showPolicyChange;
        });
    }

    canContinuePolicyChange();

    ctrl.goBackOne = () => {
        window.history.back();
    };

    $scope.$watch('policyChange', () => {
        // When we navigate between quote detail tiles, ui-router instantiates controllers
        // with _new_ prototypically-inherited $scope. When we update policyChange on that scope from within,
        // it does not gets updated on a parent (because of prototypical inheritance).
        // Then when we navigate between states again the change is lost.
        // This propagates the change to the parent state.
        $scope.$parent.policyChange = $scope.policyChange;

        if (angular.isDefined($scope.policyChange)) {
            ctrl.canWithdraw();
            $scope.uwutil = uwutil($scope.policyChange);
        }
    });

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'ActivityService', '$stateParams', 'UserService', '$filter', 'InsuranceSuiteMetadata', 'PolicyChangeService'];

export default fn;
